import { Buffer } from 'buffer';
// shpjs (shapefile upload, via @core/geometry) relies on Node's Buffer.
globalThis.Buffer = globalThis.Buffer || Buffer;
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'cesium/Build/Cesium/Widgets/widgets.css';
import Root from './Root';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
